"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const botones = require("./botones");
function isArray(x) {
    return x instanceof Array;
}
/**Componente que muestra un cuadro de dialogo. Establezca como hijos el cuerpo del dialogo */
class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.lastModalState = false;
        this.onDialogClick = (ev) => {
            ev.stopPropagation();
        };
    }
    render() {
        const fullScreenStyleDialog = this.props.fullScreen ? { width: "100%", height: "100%", margin: 0, padding: 0 } : {};
        const fullScreenStyleContent = this.props.fullScreen ? { width: "100%", height: "100%", boxShadow: "0 0 0 0" } : {};
        const fullScreenStyleBody = {};
        const propButtons = this.props.buttons;
        const botonesModal = propButtons == undefined ? [] :
            isArray(propButtons) ? propButtons :
                [propButtons];
        return (React.createElement("div", { style: {
                position: "fixed",
                background: "rgba(0,0,0,0.5)",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 10000
            }, onClick: this.props.onClose },
            React.createElement("div", { className: "modal", role: "dialog", ref: e => this.modalDiv = e, style: { display: "block", zIndex: 10001 } },
                React.createElement("div", { className: "modal-dialog", style: fullScreenStyleDialog, onClick: this.onDialogClick },
                    React.createElement("div", { className: "modal-content", style: Object.assign({
                            display: "flex",
                            flexFlow: "column nowrap",
                        }, fullScreenStyleContent) },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("button", { type: "button", className: "close", onClick: this.props.onClose }, "\u00D7"),
                            React.createElement("h4", { className: "modal-title" }, this.props.title)),
                        React.createElement("div", { className: "modal-body", style: Object.assign({
                                flex: 1,
                                display: "flex",
                                flexFlow: "column",
                                overflowY: "auto",
                            }, fullScreenStyleBody) }, this.props.children),
                        React.createElement("div", { className: "modal-footer" },
                            React.createElement("div", null,
                                React.createElement("span", undefined, ...botonesModal),
                                React.createElement(botones.CancelarButton, { onClick: this.props.onClose }))))))));
    }
}
exports.Modal = Modal;
/**Modal para borrar un elemento */
class BorrarModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnDelete = async () => {
            if (this.props.onDelete)
                await this.props.onDelete();
            if (this.props.onClose)
                this.props.onClose();
        };
        this.handleOnDelete = this.handleOnDelete.bind(this);
    }
    render() {
        return (React.createElement(Modal, { title: React.createElement("span", null,
                "Borrar ",
                this.props.entityTypeName,
                " ",
                React.createElement("b", null, this.props.entityName)), buttons: [React.createElement(botones.BorrarButton, { key: "borrar", onClick: this.handleOnDelete })], onClose: this.props.onClose },
            "\u00BFBorrar este ",
            this.props.entityTypeName,
            "?"));
    }
}
exports.BorrarModal = BorrarModal;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/modal.js
// module id = 132
// module chunks = 0